import { render, staticRenderFns } from "./onebox-pagenotfound.vue?vue&type=template&id=50e43d00&scoped=true&"
import script from "./onebox-pagenotfound.vue?vue&type=script&lang=js&"
export * from "./onebox-pagenotfound.vue?vue&type=script&lang=js&"
import style0 from "./onebox-pagenotfound.vue?vue&type=style&index=0&id=50e43d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e43d00",
  null
  
)

export default component.exports